/** @format */

import { TLocale } from '@/utils/gatsby/types';

export const nth = (n: number, locale: TLocale): string => {
  if (locale === 'en') return n + (['st', 'nd', 'rd'][((((n + 90) % 100) - 10) % 10) - 1] || 'th');
  if (locale === 'it') return n + '°';
  if (locale === 'fr') return n === 1 ? n + 'er' : n + 'e';
  if (locale === 'es') return n + 'º';
  return n.toString();
};

// Take a look here to generalize even more (but we need to know the gender of the word)

// type Gender = 'm' | 'f'; // For gender-specific languages like Italian and Spanish

// function nth(n: number, locale: TLocale, gender: Gender = 'm'): string {
//   if (locale === 'en') {
//     return n + (['st', 'nd', 'rd'][((((n + 90) % 100) - 10) % 10) - 1] || 'th');
//   }
//   if (locale === 'it') {
//     return n + (gender === 'm' ? '°' : 'ª');
//   }
//   if (locale === 'fr') {
//     if (n === 1) {
//       return gender === 'm' ? n + 'er' : n + 'ère'; // 1er for masculine, 1ère for feminine
//     }
//     return n + 'e'; // All other numbers
//   }
//   if (locale === 'es') {
//     return n + (gender === 'm' ? 'º' : 'ª');
//   }
//   return n.toString();
// }
